import { RESET_ALL as RESET_ON_LOGOUT } from 'redux-store/reducers/common-reducer';

import { createReducer } from 'utils/redux';
import { API, get } from 'utils/api';
import { logError } from 'utils/log';

import type { Action, ThunkAction } from 'types';
import type { AdminRealmOutfitDataReducerState } from 'modules/realm-outfits/types/AdminRealmOutfitDataReducer.type';

const OUTFIT_DATA_LOADED = 'adminRealmOutfitData/OUTFIT_DATA_LOADED';
const OUTFIT_DATA_RESET = 'adminRealmOutfitData/OUTFIT_DATA_RESET';
const OUTFIT_DATA_LOADING = 'adminRealmOutfitData/OUTFIT_DATA_LOADING';

const { ADMIN } = API.END_POINTS;

const initialState: AdminRealmOutfitDataReducerState = {
  isLoading: false,
  data: undefined
};

function setLoadingStatus(status: boolean): Action {
  return {
    type: OUTFIT_DATA_LOADING,
    payload: {
      status
    }
  };
}

function realmOutfitsDataLoaded(data: Array<string>): Action {
  return {
    type: OUTFIT_DATA_LOADED,
    payload: {
      data
    }
  };
}

export function resetRealmOutfitsData(): Action {
  return {
    type: OUTFIT_DATA_RESET
  };
}

export function fetchRealmOutfitsData(influencerId: number): ThunkAction {
  return async (dispatch) => {
    const baseUrl = ADMIN.REALM.matchOutfitCreators(influencerId);
    const url = `${baseUrl}&shallow=true`;

    dispatch(resetRealmOutfitsData());
    dispatch(setLoadingStatus(true));

    try {
      const { data } = await get(url);
      dispatch(realmOutfitsDataLoaded(data));
    } catch (error) {
      logError(error);
    } finally {
      dispatch(setLoadingStatus(false));
    }
  };
}

export default createReducer<AdminRealmOutfitDataReducerState, any>('adminRealmOutfitData', initialState, {
  [RESET_ON_LOGOUT]: () => initialState,
  [OUTFIT_DATA_RESET]: () => initialState,
  [OUTFIT_DATA_LOADING]: (state, { status }) => ({
    ...state,
    isLoading: status
  }),
  [OUTFIT_DATA_LOADED]: (state, { data }) => ({
    ...state,
    data
  })
});
